module.exports = __webpack_public_path__ + "static/media/SBL-4.09efd7a0.jpeg";